import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

const SidebarBox = styled(Box)(({ theme }) => ({
	width: '11.25rem',
	minWidth: '11.25rem',
	display: 'grid',
	gridTemplateColumns: 'repeat(2, 1fr)',
	backgroundColor: theme.palette.brown.main,
	position: 'relative',
}))

export { SidebarBox }
